<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      ref="queryForm"
      class="input-form-inline"
    >
      <div>
        <el-form-item class="r-20">
          <el-input
            size="mini"
            v-model="queryContent"
            placeholder="故障内容"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="queryFault">查询</el-button>
      </div>
      <div style="margin-bottom:20px">
        <el-button
          v-if="hasPerm('error:content:save')"
          type="primary"
          @click="addFault"
          >新增</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('error:content:delete')"
          type="danger"
          @click="delFault"
          >删除</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding:0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="260"></el-table-column>
      <el-table-column prop="content" label="故障内容"></el-table-column>
      <el-table-column prop="modifyTime" label="修改日期"></el-table-column>
      <el-table-column prop="modifyName" label="修改用户"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('error:content:update')"
            @click.stop="editFault(scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!--新增用户对话框-->
    <el-dialog :title="dialogTitle" :visible.sync="visible" class="mini-dialog">
      <el-form
        :rules="rules"
        ref="faultForm"
        :model="faultForm"
        size="mini"
        :inline="true"
      >
        <el-form-item class="input-area" prop="addr" label="故障内容">
          <el-input
            type="textarea"
            v-model="faultForm.content"
            placeholder="请输入故障内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        content: [
          {
            required: true,
            trigger: "change",
            message: "请输入故障内容",
          },
        ],
      },
      faultForm: {
        content: "",
      },
      queryContent: "",
      currentPage: 1,
      limit: 10,
      total: 0,
      tableVal: [],
      tableData: [],
      dialogTitle: "",
      visible: false,
      editTag: "0",
      faultId: "",
    }
  },
  created() {
    this.getFaultList()
  },
  methods: {
    async getFaultList() {
      let obj = {}
      obj.limit = this.limit
      obj.page = this.currentPage
      obj.content = this.queryContent
      let _this = this
      let { data: res } = await _this.$axios.get("/api/error/content/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      } else {
        _this.$message.warning(res.msg)
      }
    },
    queryFault() {
      this.getFaultList()
    },
    handleSelectionChange(val) {
      this.tableVal = val
    },
    handleClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    addFault() {
      this.editTag = "0"
      //清空表单数据
      this.faultForm.content = ""
      //设置弹框标题
      this.dialogTitle = "新增故障内容"
      this.visible = true
    },
    editFault(rowData) {
      this.editTag = "1"
      //设置弹框标题
      this.dialogTitle = "修改故障内容"
      this.visible = true
      this.faultId = rowData.id
      this.faultForm.content = rowData.content
      console.log(rowData)
    },
    saveOrUpdate() {
      let _this = this
      let data = []
      let obj = {}
      obj.content = _this.faultForm.content
      _this.$refs.faultForm.validate(async (valid) => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post(
              "/api/error/content?content=" + _this.faultForm.content
            )
          } else {
            data = await _this.$axios.patch(
              "/api/error/content?content=" +
                _this.faultForm.content +
                "&id=" +
                _this.faultId
            )
          }
          let res = data.data
          if (res.code == 1) {
            //信息提示
            _this.$message.success("操作成功")
            //刷新表格
            _this.getFaultList()
            _this.visible = false
          } else {
            _this.$message.warning(res.msg)
          }
        }
      })
    },
    delFault() {
      let _this = this
      //多选删除
      let errorIds = _this.$getIds(_this.tableVal)
      if (!errorIds) {
        return
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/error/content", {
            data: JSON.stringify(errorIds),
          })
          if (res.code == 1) {
            _this.$message.success("操作成功")
            let totalPage = Math.ceil((_this.total - 1) / 10)
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage
            _this.currentPage = currentPage < 1 ? 1 : currentPage
            _this.getFaultList()
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getFaultList()
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  background-color: #fff;
  padding: 0 20px;
}
.con-wrap .el-container {
  background-color: #fff;
  padding: 0 20px;
}
.mini-dialog .input-area /deep/ {
  margin-bottom: 0;
  .el-textarea {
    height: auto;
  }
  .el-textarea__inner {
    height: auto;
    max-height: 100px;
  }
  .el-form-item__content {
    height: auto;
  }
}
.mini-dialog /deep/ .el-dialog__body {
  padding-bottom: 0;
}
</style>
